import React from 'react';

export default function Component(props) {

const { question, answersList, ansNPSInput, surveyLanguageCode, surveyScreenData, isMobile, getTheme, SurveyAttributes } = props;
  let [showValue2, handleValue2 ] = React.useState(111)


let tempData = CustomLabels("Dissatisfied", "Dissatisfied",question);

console.log("---------->tempData----------->",tempData)

let showValue = false;
function handleValue(){}

function CustomLabels(optionID,optionName, question){
  let surveyLanguageCode = "customNPS";
  return  (surveyLanguageCode!=='')?
  (question && question.transl && 
    question.transl[surveyLanguageCode] && 
        question.transl[surveyLanguageCode][optionID])?
          question.transl[surveyLanguageCode][optionID]:optionName
  :optionName
}

function NPSName(optionID, optionName, surveyLanguageCode, question){
  return  (surveyLanguageCode!=='')?
  (question && question.transl && 
    question.transl[surveyLanguageCode] && 
      question.transl[surveyLanguageCode].optionsList && 
        question.transl[surveyLanguageCode].optionsList[optionID])?
          question.transl[surveyLanguageCode].optionsList[optionID]:optionName
  :optionName
}

function NPSColor(question){



  let Color = "#a3a3a3";
  let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
  let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
  if(showValue || showValue===0){
    answer = showValue;
  }

  
  if(answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6 ){
    Color = "#2074e3";
    if(answer === 0 || answer === 1 || answer === 2){
      Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied",question) , surveyLanguageCode, question)
    }
    else if(answer === 3 || answer === 4){
      Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied",question) , surveyLanguageCode, question)
      console.log('Dissatisfied Name: ',Name)
    }
    else if(answer === 5 || answer === 6){
      Name = NPSName("Neither", CustomLabels("Neither", "Neither",question), surveyLanguageCode, question)
    }
  }
  else if(answer === 7){
    Color = "#2074e3";
    Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied",question) , surveyLanguageCode, question)
  }
  else if(answer === 8 || answer === 9 || answer === 10){
    Color = "#2074e3";
    Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied",question) , surveyLanguageCode, question)
  }

  return {
    color:Color,
    name:Name
  }
}



function NPSColor2(question){



  let Color = "#a3a3a3";
  let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
  let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
  if(showValue2 || showValue2===0){
    answer = showValue2;
  }

  
  if(answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6 ){
    Color = "#2074e3";
    if(answer === 0 || answer === 1 || answer === 2){
      Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied",question), surveyLanguageCode, question)
    }
    else if(answer === 3 || answer === 4){
      Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied",question), surveyLanguageCode, question)
      console.log('Dissatisfied Name: ',Name)
    }
    else if(answer === 5 || answer === 6){
      Name = NPSName("Neither", CustomLabels("Neither", "Neither",question), surveyLanguageCode, question)
    }
  }
  else if(answer === 7){
    Color = "#2074e3";
    Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied",question), surveyLanguageCode, question)
  }
  else if(answer === 8 || answer === 9 || answer === 10){
    Color = "#2074e3";
    Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied",question), surveyLanguageCode, question)
  }

  return {
    color:Color,
    name:Name
  }
}




function matchAnswer(answersList1,question1){
  let value = "";
  if(answersList1 && answersList1.length>0){
    let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
    if(getIndex1!==-1){
      value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer?answersList1[getIndex1].answer:"";
    }
  }
  return value
}


return(
    <>
        {/* <span className="italic text-gray-500 text-sm px-4">10 = great place to work, 1 = not so great place to work *</span> */}
        <span className={(isMobile?"text-sm ":"text-base ")+ " text-white pt-4 px-4 md:hidden block italic font-medium"} style={{color:getTheme("text","#FFFFFF")}} >
          {SurveyAttributes("I am not like this")?SurveyAttributes("I am not like this"):"I am not like this"}
          </span>

          <div className="grid md:grid-cols-10 grid-cols-5 gap-4 md:py-6 py-2  lg:text-lg text-sm mx-4">
            {/* 1 */}
            {[...Array(11).keys()].map((value,index)=>
            <>
            {((value).toString()===matchAnswer(answersList,question))?
              <>
              <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
              style={{background:getTheme("lightblue",NPSColor(question,surveyLanguageCode).color), color:getTheme("textblue","#FFFFFF"), borderColor:getTheme("textblue","#FFFFFF")}}
              className="my-2 bg-red-500 rounded-md md:p-4 md:py-4 p-4 py-2 text-white border border-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer px-3">
              {value}
              </span>
              </>
              :
            <>
            {(value) <= (showValue || parseInt(matchAnswer(answersList,question)))?
            <>
              <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
                style={{background:getTheme("lightblue",NPSColor(question,surveyLanguageCode).color), color:getTheme("textblue","#FFFFFF"), borderColor:getTheme("textblue","#FFFFFF")}}
                className="my-2 bg-red-500  rounded-md md:p-4 md:py-4 p-4  text-white border border-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
                {value}
              </span>
              </>
            :
            <>
            <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
                className={(getTheme("hoverActive"," hover:bg-white/40 hover:text-white "))+(getTheme("textOption"," border-white bg-white/10 "))+" border my-2  rounded-md md:p-4 md:py-4 p-4  flex items-center  justify-center text-[#3D405B]   font-medium  cursor-pointer  px-3 transition-all duration-200"}>
              {value}
              </span>
            </>
            }
            </>
            }
            </>
            )}

          </div>

          <div className="flex md:justify-between justify-end text-white italic" style={{color:getTheme("text","#FFFFFF"), borderColor:getTheme("text","#FFFFFF")}}>
            <span className={(isMobile?"text-sm ":"text-base ")+" px-4 font-medium md:block hidden"}>{SurveyAttributes("I am not like this")?SurveyAttributes("I am not like this"):"I am not like this"}</span>
            <span className={(isMobile?"text-sm ":"text-base ")+" px-4 font-medium"}>{SurveyAttributes("I am like this")?SurveyAttributes("I am like this"):"I am like this"}</span>
          </div>
         
       


   
    </>
  );}